"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//open layers
require("ol/ol.css");
var ol_1 = require("ol");
var layer_js_1 = require("ol/layer.js");
var Graticule_js_1 = __importDefault(require("ol/Graticule.js"));
var style_js_1 = require("ol/style.js");
//sources
var OSM_1 = __importDefault(require("ol/source/OSM"));
//general
var proj_js_1 = require("ol/proj.js");
var route_js_1 = __importDefault(require("./../classes/route.js"));
var ship_js_1 = __importDefault(require("./../../dashboard/classes/ship.js"));
LocateMapDirective.$inject = ['$http', 'config', 'api', '$timeout', '_trip'];
function LocateMapDirective($http, config, api, $timeout, _trip) {
    return {
        restrict: 'E',
        template: require('./views/locate-map.html'),
        scope: {
            trip: '='
        },
        link: function (scope, el, attrs, ctrl) {
            var self = this;
            $timeout(function () {
                var shipLayer = new ship_js_1.default();
                var routeLayer = new route_js_1.default();
                var view = new ol_1.View({
                    center: proj_js_1.fromLonLat([15.25, 38.15]),
                    zoom: 5,
                    minZoom: 5,
                    maxZoom: 14,
                    projection: 'EPSG:3857',
                    enableRotation: false
                });
                var map = new ol_1.Map({
                    target: angular.element(el[0].querySelector('.map-core'))[0],
                    layers: [],
                    loadTilesWhileAnimating: false,
                    view: view
                });
                var baseLayer = new layer_js_1.Tile({
                    preload: 4,
                    source: new OSM_1.default({}),
                });
                map.addLayer(baseLayer);
                // Create the graticule component
                var graticule = new Graticule_js_1.default({
                    // the style to use for the lines, optional.
                    strokeStyle: new style_js_1.Stroke({
                        color: '#b8b8b8',
                        width: 2,
                        lineDash: [0.5, 4]
                    }),
                    showLabels: true
                });
                graticule.setMap(map);
                map.addLayer(shipLayer.get());
                map.addLayer(routeLayer.get());
                api.get('/harbour/' + scope.trip.aharbour).then(function (response) {
                    scope.aharbour = response;
                    api.get('/harbour/' + scope.trip.dharbour).then(function (response) {
                        scope.dharbour = response;
                        api.get('/ships').then(function (response) {
                            scope.ship = _.find(response, { id: scope.trip.ship });
                            var ship_feature = shipLayer.addFeature();
                            api.get('/observation/esnah/latest', { si: scope.ship.si }).then(function (info) {
                                scope.info = info;
                                shipLayer.setPosition(ship_feature, proj_js_1.fromLonLat([parseFloat(info.lon), parseFloat(info.lat)]));
                                scope.data = {
                                    aharbour: scope.trip.aport + ', ' + scope.trip.acountry,
                                    dharbour: scope.trip.dport + ', ' + scope.trip.dcountry,
                                    atime: scope.trip.atime,
                                    dtime: scope.trip.dtime,
                                    ship: scope.ship.name,
                                    speed: parseFloat(scope.info.speed).toFixed(2),
                                    hdg: parseFloat(scope.info.hdg).toFixed(2),
                                    lon: parseFloat(scope.info.lon).toFixed(2),
                                    lat: parseFloat(scope.info.lat).toFixed(2)
                                };
                            });
                            _trip.getPlannedRoute(scope.trip.planned_route_id).then(function (response) {
                                var planned_route = _trip.unpackRoute(response);
                                var points = [];
                                _.each(planned_route.route, function (val, idx) {
                                    points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                                });
                                routeLayer.drawRoute(points);
                                map.getView().fit(routeLayer.getExtent(), { padding: [50, 200, 200, 50], duration: 1000 });
                            });
                        });
                    });
                });
            }, 500);
        }
    };
}
exports.LocateMapDirective = LocateMapDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/directives/LocateMapDirective.js
// module id = 596
// module chunks = 0